/**
 * FilterSection Component
 * 수수료 관리 검색 필터 섹션
 */
import React, { useMemo } from 'react';
import SearchableSelect, { SelectOption } from '@/shared/components/forms/SearchableSelect';
import { STATUS_FILTER_OPTIONS } from "../lib/feeManagement.helpers";
import '@/shared/styles/search-form.css';

// 필터 기본값
const DEFAULT_FILTER = {
    ALL: '전체'
} as const;

interface FilterSectionProps {
    /** 선택된 협력사 */
    partnerId: string;
    /** 협력사명 목록 */
    supplierNames: string[];
    /** 선택된 상태 */
    statusFilter: string;
    /** 협력사 변경 핸들러 */
    onPartnerChange: (value: string) => void;
    /** 상태 변경 핸들러 */
    onStatusChange: (value: string) => void;
    /** 검색 실행 핸들러 */
    onSearch: () => void;
    /** 빠른 필터 핸들러 (버튼 클릭 시 즉시 필터링) */
    onQuickFilter: (status: string) => void;
}

const FilterSection: React.FC<FilterSectionProps> = ({
    partnerId,
    supplierNames,
    statusFilter,
    onPartnerChange,
    onStatusChange,
    onSearch,
    onQuickFilter
}) => {
    // 협력사 옵션을 SelectOption 형식으로 변환
    const supplierOptions: SelectOption[] = useMemo(() => {
        return supplierNames.map((name) => ({
            value: name,
            label: name
        }));
    }, [supplierNames]);

    return (
        <div className="card search-card">
            <div className="card-body">
                {/* 빠른 필터 버튼 */}
                <div className="quick-filter-row">
                    <div className="quick-filter-buttons">
                        {STATUS_FILTER_OPTIONS.map(option => (
                            <button
                                key={option.value}
                                type="button"
                                className={`quick-filter-btn ${statusFilter === option.value ? 'active' : ''}`}
                                onClick={() => onQuickFilter(option.value)}
                            >
                                {option.label}
                            </button>
                        ))}
                    </div>
                </div>

                <div className="search-form fee-search-form">
                    {/* 협력사 */}
                    <div className="form-group">
                        <div className="form-field">
                            <label className="form-label">
                                <i className="fas fa-building" />
                                협력사
                            </label>
                            <SearchableSelect
                                options={supplierOptions}
                                value={partnerId === DEFAULT_FILTER.ALL ? '' : partnerId}
                                onChange={(value) => onPartnerChange(value || DEFAULT_FILTER.ALL)}
                                placeholder="협력사 검색..."
                                showAllOption={true}
                                allOptionLabel={DEFAULT_FILTER.ALL}
                            />
                        </div>
                    </div>

                    {/* 버튼 그룹 */}
                    <div className="form-group button-group">
                        <button className="btn btn-primary" onClick={onSearch}>
                            <i className="fas fa-search" />
                            조회
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FilterSection;
